/*global _ */
import BaseSelectMixin from '../re-select/mixin'
const mixins = [BaseSelectMixin]
import Select2 from 'v-select2-component'
const components = {Select2}
import defaultSettings from './settings'
//import 'select2-bootstrap-theme/dist/select2-bootstrap.min.css'

export default {
  name: 're-select2',
  components,
  mixins,
  props: {
    tags: {
      type: [Boolean, Number, String, Array],
      default: false
    },
    settingsName: {
      type: String,
      default: 'default',
    },
    settings: {
      type: Object,
      default: () => ({})
    },
    width: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      defaultSettings
    }
  },
  computed: {

  },
  watch: {

  },
  methods: {
    getSettings() {
      let settings = this.settings
      if (_.isEmpty(settings)) {
        settings = this.defaultSettings[this.settingsName] || this.defaultSettings['default']
      }
      const attrs = this.$$attrs()
      settings = {...settings, ...attrs}
      settings.selectionCssClass = this.inputClass
      if (this.tags) {
        settings.tags = this.tags
      }
      if (!_.isNil(this.width)) {
        settings.width = this.width
      }
      return settings
    },
    getOptions() {
      return _.map(this.optionsList || [], o => {
        return {
          id: this.getOptionValue(o),
          text: this.getOptionLabel(o),
          ...this.getOptionAttrs(o)
        }
      })
    },
    onInput(value) {
      this.isDirtyState = true
      this.model = value
    },
  }
}
